var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disputed-orders__empty glass-card"},[_c('div',{staticClass:"empty-icon"},[_vm._v("✓")]),_vm._v(" "),_c('h3',[_vm._v("No disputed orders found")]),_vm._v(" "),_c('p',[_vm._v("All disputes have been resolved or no disputes exist.")])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba0cc1e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminTools/DisputedOrders/components/EmptyState.vue
// module id = null
// module chunks = 